import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { MdModeEdit } from "react-icons/md";

import {
    CampaignDetails,
    updateLuckyDraw,
    CampaignDetailsExport,
} from "Services/Requests";
import {
    showWarningAlert,
    showErrorAlert,
    showSuccessAlert,
} from "Util/Alerts";
import ReactPaginate from "react-paginate";
import TableClasses from "Components/TableLoad";
import Moment from "react-moment";
import Styles from "Styles/Styles.module.css";
import { detailsType, DrawTypes } from "./Types";
// import moment from "moment";
import Modal from "./WinnerAnnounce/modal";
import { CSVLink } from "react-csv";
import moment from "moment";
import Testimonials from "./TestimonialsLink/modal";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { message } from "antd";

function Details() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(true);
    const [Downloadloading, setDownloadLoading] = useState<boolean>(false);
    const [List, setList] = useState<detailsType[]>([]);
    const [data, setData] = useState<any>([]);
    const [Showmodal, setShowModal] = useState(false);
    const [ModalLoad, setModalLoad] = useState(false);
    const [TestimonialsModal, setTestimonialsModal] = useState(false);
    const csvRef = useRef<any>(null); // Ref for CSVLink

    const [selectedWinner, setSelectedWinner] = useState<any>();
    const [campaignDetails, setCampaignDetails] = useState<DrawTypes>({
        draw_date: "",
        winner: "",
        sold_qty: 0,
        image_url: "",
        stock_available: 0,
        campaign_code: 0,
        campaign_id: 0,
        product_name: "",
        giveaway_product_name: "",
        status: 0,
        first_name: "",
        last_name: "",
        video_url: "",
        campaign_stock: 0,
        testimonial_url: "",
        user_id: "",
        coupon_id: 0,
    });
    const [Count, setCount] = useState(0);
    const [forcepage, setfocrcepage] = useState(0);
    const { type } = useParams();

    const getOrders = async (page: any) => {
        try {
            const response = await CampaignDetails(type, page);
            if (response?.data?.status === 1) {
                // setOrders(response?.data?.data);
                setCampaignDetails(response.data?.campaign);
                setList(response?.data?.data);
                setCount(response?.data?.pageCount);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        let page = searchParams.get("page") ?? 1;

        setSearchParams({
            page: page.toString(),
        });
        setfocrcepage(Number(page) - 1);
        getOrders(page);
    }, []);
    const handlePageChange = (selectedObject: any) => {
        console.log(selectedObject);
        // setcurrentPage(selectedObject.selected);
        // handleFetch();
        let status = searchParams.get("status") ?? 1;
        setSearchParams({
            status: status.toString(),
            page: selectedObject.selected + 1,
        });
        setfocrcepage(selectedObject.selected);
        getOrders(selectedObject.selected + 1);
        window.scrollTo({ top: 10, behavior: "smooth" });
    };
    let TableHead = [
        "Name",
        "Email",
        "Phone Number",
        "Product Name",
        "Sale Price",
        "SKU",
        "Purchase Date",
        "Coupon Code",
        "Actions",
    ];
    const updateData = async (data: any) => {
        let Body = {
            ...data,
            winner: campaignDetails.user_id,
            coupon_id: campaignDetails.coupon_id,
            campaign_id: type,
        };
        setLoading(true);
        setModalLoad(true);
        try {
            const response = await updateLuckyDraw(Body);
            setModalLoad(false);
            setShowModal(false);
            if (response?.data?.status === 1) {
                getOrders(searchParams.get("page"));
                showSuccessAlert(response?.data?.message);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setModalLoad(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 300);
        }
    };
    const updateTestimonialLink = async (data: any) => {
        let Body = {
            ...data,

            campaign_id: type,
        };
        setLoading(true);
        setModalLoad(true);
        try {
            const response = await updateLuckyDraw(Body);
            setModalLoad(false);
            setShowModal(false);
            if (response?.data?.status === 1) {
                getOrders(searchParams.get("page"));
                setTestimonialsModal(false);
                showSuccessAlert(response?.data?.message);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setModalLoad(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 300);
        }
    };
    const ExportData = async () => {
        setDownloadLoading(true);
        try {
            const response = await CampaignDetailsExport(type);
            if (response?.data?.status === 1) {
                setData([
                    [
                        "S.no",
                        "Campaign Code",
                        "Customer Name",
                        "Phone Number",
                        "Product Name",
                        "SKU",
                        "Sale Price",
                        "Date of Purchase",
                        "Coupon Code",
                        "Telegram link",
                    ],
                    ...response?.data?.data.map((item: any, index: any) => [
                        index + 1,
                        item.campaign_code,
                        item.first_name + " " + item.last_name,
                        item.mobile_number,
                        item.product_name,
                        item.sku,
                        item.price,
                        moment(item.created_at).format("DD-MM-YYYY"),
                        item.coupon_code,
                        item.telegram_link,
                    ]),
                ]);
                setTimeout(() => {
                    csvRef.current?.link.click(); // Manually trigger download
                    setDownloadLoading(false);
                }, 1000);
            } else {
                setDownloadLoading(false);
                // done(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            console.log(err);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
            setLoading(false);
        }
    };
    const updateProfile = () => {
        setShowModal(true);
        let selected = List.find(
            (item) => item.user_id == campaignDetails.user_id
        );
        console.log(selected, List, campaignDetails);
        setSelectedWinner(selected);
    };
    const Button = styled.button`
    border: 1px solid var(--GrayColor, #ccc);
    color: black;
    padding: 5px 13px;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
  
    &:hover {
      background-color: lightgray; /* Default to green if PrimaryColor is not defined */
      color: white;
    }
  `;

    function isValidURL(url: string) {
        try {
            const parsed = new URL(url);
            if (parsed.protocol === "http:" || parsed.protocol === "https:") {
                window.open(url, "_blank");
            } else {
                throw new Error("Invalid protocol");
            }
        } catch (_) {
            message.warning("Invalid Link");
        }
    }
    return (
        <div className={Styles["Container"]}>
            <Modal
                ModalLoad={ModalLoad}
                details={campaignDetails}
                isModalVisible={Showmodal}
                setisModalVisible={setShowModal}
                updateData={updateData}
            />
            <Testimonials
                ModalLoad={ModalLoad}
                details={campaignDetails}
                isModalVisible={TestimonialsModal}
                setisModalVisible={setTestimonialsModal}
                updateData={updateTestimonialLink}
            />
            <header style={{ display: "flex", justifyContent: "flex-start" }}>
                <Button onClick={() => navigate("/auth/draw?page=1")}>
                    Back
                </Button>
                <h3>Campaign Details</h3>
            </header>
            {
                <div className={Styles["Campaign_details"]}>
                    <div>
                        <h3>Campaign Code </h3>
                        <span>:</span>
                        {campaignDetails?.campaign_code
                            ? campaignDetails?.campaign_code
                            : "NA"}
                    </div>
                    <div>
                        <h3>Draw Date </h3>
                        <span>:</span>
                        {campaignDetails?.draw_date ? (
                            <Moment format="DD-MM-YYYY" utc>
                                {campaignDetails?.draw_date}
                            </Moment>
                        ) : (
                            "NA"
                        )}
                    </div>
                    <div>
                        <h3>Winner </h3>
                        <span>:</span>
                        {campaignDetails?.winner && (
                            <>
                                {campaignDetails.first_name}{" "}
                                {campaignDetails.last_name}
                            </>
                        )}
                        {campaignDetails?.winner
                            ? `(${campaignDetails?.winner})`
                            : "NA"}
                    </div>
                    <div>
                        <h3>Testimonials </h3>
                        <span>:</span>
                        {campaignDetails?.winner ? (
                            <p style={{ display: "flex", gap: "0.4rem" }}>
                                {campaignDetails?.testimonial_url &&
                                campaignDetails?.testimonial_url != "NA" ? (
                                    <button
                                        onClick={() =>
                                            isValidURL(
                                                campaignDetails?.testimonial_url ||
                                                    ""
                                            )
                                        }
                                        style={{
                                            border: "none",
                                            textDecoration: "underline",
                                        }}>
                                        Link
                                    </button>
                                ) : (
                                    "NA"
                                )}
                                <button
                                    style={{ border: "none" }}
                                    onClick={() => {
                                        setTestimonialsModal(true);
                                    }}>
                                    <MdModeEdit />
                                </button>
                            </p>
                        ) : (
                            "NA"
                        )}
                    </div>
                    {campaignDetails?.winner && (
                        <div>
                            <h3>Public Profile </h3>
                            <span>:</span>
                            <p style={{ display: "flex", gap: "0.4rem" }}>
                                {campaignDetails?.public_url ? (
                                    <button
                                        onClick={() =>
                                            isValidURL(
                                                campaignDetails?.public_url ||
                                                    ""
                                            )
                                        }
                                        style={{
                                            border: "none",
                                            textDecoration: "underline",
                                        }}>
                                        Link
                                    </button>
                                ) : (
                                    "NA"
                                )}
                                <button
                                    onClick={updateProfile}
                                    style={{ border: "none" }}>
                                    <MdModeEdit />
                                </button>
                            </p>
                        </div>
                    )}
                </div>
            }

            <div className={Styles["tableWrapper"]}>
                <header className={Styles["wrap"]}>
                    <h3>User list</h3>
                    <button
                        onClick={ExportData}
                        disabled={loading}
                        className={Styles["export"]}>
                        {Downloadloading ? "Exporting..." : "Export Data"}
                    </button>
                    <CSVLink
                        data={data}
                        filename="UserList.csv"
                        className="hidden"
                        style={{ display: "none" }}
                        ref={csvRef}
                    />
                </header>
                {loading ? (
                    <TableClasses TableHead={TableHead} />
                ) : (
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {List.length > 0 ? (
                                List.map((item) => (
                                    <tr>
                                        <td>
                                            {item.first_name} {item.last_name}
                                        </td>
                                        <td>{item.email}</td>
                                        <td>{item.mobile_number}</td>
                                        <td>{item.product_name}</td>
                                        <td>{item?.product_price}</td>
                                        <td>{item?.sku}</td>
                                        <td>
                                            <Moment format="DD-MM-YYYY" utc>
                                                {item?.created_at}
                                            </Moment>
                                        </td>
                                        <td>{item.coupon_code}</td>
                                        <td>
                                            {!campaignDetails?.winner &&
                                            campaignDetails?.draw_date &&
                                            campaignDetails?.draw_date !=
                                                "NA" ? (
                                                <button
                                                    onClick={() => {
                                                        setShowModal(true);
                                                        setSelectedWinner(item);
                                                    }}
                                                    style={{
                                                        padding: "0.3rem",
                                                    }}>
                                                    Announce Winner
                                                </button>
                                            ) : (
                                                "NA"
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No Data found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
                {List?.length > 0 && (
                    <ReactPaginate
                        pageCount={Count}
                        // pageRange={2}
                        forcePage={forcepage}
                        marginPagesDisplayed={2}
                        onPageChange={handlePageChange}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        activeClassName={"active"}
                    />
                )}
            </div>
        </div>
    );
}

export default Details;
